export const NOTIFICATION_CENTER_ORIGIN = "notification-center";
export const DASHBOARD_ORIGIN = "dashboard";

export type TimelineOrigin =
	| typeof NOTIFICATION_CENTER_ORIGIN
	| typeof DASHBOARD_ORIGIN;

export const hasTimelineOrigin = (state: unknown): boolean => {
	if (typeof state !== "object" || state === null || Array.isArray(state)) {
		return false;
	}
	const from = (state as { from?: unknown }).from;
	return from === NOTIFICATION_CENTER_ORIGIN || from === DASHBOARD_ORIGIN;
};
